import { render, staticRenderFns } from "./CbsObjectCube.vue?vue&type=template&id=a7866acc&scoped=true"
import script from "./CbsObjectCube.vue?vue&type=script&lang=js"
export * from "./CbsObjectCube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7866acc",
  null
  
)

export default component.exports